import React from 'react';
import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";

import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Register from './pages/Register';
import Settings from './pages/Settings';
import Payment from './pages/Payment';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import MyTranscriptions from './pages/MyTranscriptions';
import FileList from './pages/FileList';
import SuperAdminLogin from './pages/superadmin/Login';
import SuperAdminDashboard from './pages/superadmin/Dashboard';
import AdminQueue from './pages/superadmin/Queue';
import AdminPayments from './pages/superadmin/Payments';
import AdminUsers from './pages/superadmin/Users';
import AdminNotifications from './pages/superadmin/Notifications';
import AdminSettings from './pages/superadmin/Settings';
import { NotificationProvider } from './NotificationContext';
import Notifications from './components/Notifications';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FAQ from './pages/FAQ';
import SampleTranscripts from './pages/SampleTranscripts';
import FilesUpload from './pages/FIlesUpload';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import EditorPage from './pages/editor/EditorPage';
import EditorHomePage from './pages/editor/EditorHomePage';

import DashboardLayout from './DashboardLayout';
import Layout from './Layout';
import PrivateRoute from './utils/PrivateRoute';
import SuperAdminPrivateRoute from './utils/SuperAdminPrivateRoute';
import SuperAdminDashboardLayout from './SuperAdminDashboardLayout';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "services", element: <Services /> },
      { path: "login", element: <Login /> },
      { path: "register", element: <Register /> },
      { path: "privacy-policy", element: <PrivacyPolicy /> },
      { path: "faq", element: <FAQ /> },
      { path: "sample-transcripts", element: <SampleTranscripts /> },
      { path: "upload", element: <FilesUpload /> },
      { path: "forgot-password", element: <ForgotPassword /> },
      { path: "reset-password", element: <ResetPassword /> },
      { path: "superadmin/login", element: <SuperAdminLogin /> },
    ],
  },
  {
    path: "/dashboard",
    element: (
      <PrivateRoute>
        <DashboardLayout />
      </PrivateRoute>
    ),
    children: [
      { path: "", element: <Dashboard /> },
      { path: "settings", element: <Settings /> },
      { path: "payment", element: <Payment /> },
      { path: "payment/success", element: <PaymentSuccess /> },
      { path: "payment/cancel", element: <PaymentCancel /> },
      { path: "contact", element: <Contact /> },
      { path: "upload", element: <FilesUpload /> },
      { path: "my-transcriptions", element: <MyTranscriptions /> },
      { path: "files", element: <FileList /> },
      { path: "notifications", element: <Notifications /> },
    ],
  },
  {
    path: "/superadmin/dashboard",
    element: (
      <SuperAdminPrivateRoute>
        <SuperAdminDashboardLayout />
      </SuperAdminPrivateRoute>
    ),
    children: [
      { path: "", element: <SuperAdminDashboard /> },
      { path: "queue", element: <AdminQueue /> },
      { path: "payments", element: <AdminPayments /> },
      { path: "users", element: <AdminUsers /> },
      { path: "notifications", element: <AdminNotifications /> },
      { path: "settings", element: <AdminSettings /> }
    ]
  },
  {
    path: "/editor",
    element: (
      <PrivateRoute>
        <EditorPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/editor-home",
    element: <EditorHomePage />,
  }
]);

function App() {
  return (
    <NotificationProvider>
      <RouterProvider router={router} />
    </NotificationProvider>
  );
}

export default App;
